import { useBook5 } from '@orientaction/hooks_book';
import EbookReaderLayout from './components/EbookReaderLayout';
import Step5Content from './components/Step5Content';
import { useLegacyEbookReader } from './hooks/useLegacyEbookReader';

const EbookDevStep5 = () => {
  const { initValue, getMyValueBook, setId } = useBook5();
  const reader = useLegacyEbookReader({
    getMyValueBook,
    hydrateValue: initValue,
    setId,
  });

  return (
    <EbookReaderLayout {...reader} ebookName="l’Étape 5">
      {(readOnly) => <Step5Content readOnly={readOnly} />}
    </EbookReaderLayout>
  );
};

export default EbookDevStep5;
